import { Messages } from '~src/codegen/Localize';
import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainLettersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainLettersPolicy = new MustContainLettersPolicy();

    private constructor() {
        super(/[a-zA-Z]/);
    }

    public static getPolicy(): MustContainLettersPolicy {
        return MustContainLettersPolicy.instance;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_mustContainLetters();
    }

    public getTestId(): string {
        return MustContainLettersPolicy.name;
    }
}
